/**
 * ─────────────────────────────────────────────────────────────────────────
 *  SVARA CHAKRA — SOUND CONFIGURATION
 * ─────────────────────────────────────────────────────────────────────────
 *
 *  This is the ONLY file you need to edit to plug in your own professionally
 *  produced soundscape. Nothing else in the app needs to change.
 *
 *  HOW TO USE YOUR OWN AUDIO
 *  1. Drop your files into:  /app/frontend/public/audio/
 *        e.g.  svara-ambient.mp3   (a seamless, loopable ambient bed)
 *              reveal-chime.mp3     (optional — a single soft bell/bowl)
 *  2. Set the paths below (paths are relative to the site root):
 *        ambientSrc: "/audio/svara-ambient.mp3",
 *        chimeSrc:   "/audio/reveal-chime.mp3",
 *
 *  BEHAVIOUR
 *  • If `ambientSrc` is null  → the built-in procedural placeholder is used.
 *  • If `ambientSrc` is set   → your file is streamed and cross-faded instead.
 *  • If `chimeSrc` is null     → a soft procedural bell is used for the
 *                                numerology reveal moment.
 *
 *  The engine that plays the sound is chosen automatically (see audio/index.js)
 *  and always exposes the same interface: fadeIn(), fadeOut(), playChime().
 * ─────────────────────────────────────────────────────────────────────────
 */

export const AUDIO_CONFIG = {
  // Ambient soundscape loop. null → use the procedural placeholder engine.
  ambientSrc: null, // e.g. "/audio/svara-ambient.mp3"

  // Optional one-shot reveal chime. null → use the procedural bell fallback.
  chimeSrc: null, // e.g. "/audio/reveal-chime.mp3"

  // Target ambient volume (0–1). Kept intentionally very low and immersive.
  volume: 0.13,

  // Volume for the reveal chime (0–1).
  chimeVolume: 0.5,

  // Fade timings (seconds) for enabling / disabling the sound experience.
  fadeInSeconds: 3,
  fadeOutSeconds: 2,
};
